module.exports = __webpack_public_path__ + "static/media/del_btn_line.8a9fefa4.svg";